// https://stackoverflow.com/a/4819886/598962
export const isTouchEnabled = 'ontouchstart' in window || !!navigator.maxTouchPoints;
